import { createMigration } from "@verdant-web/store";
import v1Schema from "../client/schemaVersions/v1.js";
export default createMigration(v1Schema);
//# sourceMappingURL=v1.js.map